import { getServerURL } from "../shared/sharedFunctions.jsx";
import companyService from "./companyService.js";
import userService from "./userService.js";

const VscanService = () => {
	const pub = {};
	
	pub.vscanReports = [];
	
	pub.getVscanReports = (companyId) => {
		return new Promise((resolve, reject) => {			
			const req = {
				method: "GET",
				headers: { "Content-Type": "application/json", "access_token": userService.AccessToken() }
			};
			
			fetch(`${getServerURL()}/api/vscan/${companyId}`, req)
			.then((response) => {
				if (response.status !== 200) {
					throw new Error(response.status);
				}
				
				return response.json();
			})
			.then((response) => {
				pub.vscanReports = response.vscanReports;
				resolve();
			})
			.catch(err => {
				console.log(err.message);
				reject(err);
			});
		});
	};
	
	pub.deleteVscanReport = (companyId, vscanReportId) => {
		return new Promise((resolve, reject) => {			
			const req = {
				method: "DELETE",
				headers: { "Content-Type": "application/json", "access_token": userService.AccessToken() }
			};
			
			fetch(`${getServerURL()}/api/vscan/${companyId}/${vscanReportId}`, req)
			.then((response) => {
				if (response.status !== 200) {
					throw new Error(response.status);
				}
				
				return response.json();
			})
			.then((response) => {
				pub.vscanReports = response.vscanReports;
				resolve();
			})
			.catch(err => {
				console.log(err.message);
				reject(err);
			});
		});
	};
	
	pub.addVscanReport = (vscanReport)=> {
		return new Promise((resolve, reject) => {			
			const req = {
				method: "POST",
				headers: { "Content-Type": "application/json", "access_token": userService.AccessToken() },
				body: JSON.stringify({
					vscanFile: vscanReport.vscanFile,
					company_id: companyService.selectedCompany.id,
				})
			};
			
			fetch(`${getServerURL()}/api/vscan`, req)
			.then((response) => {
				if (response.status !== 200) {
					throw new Error(response.status);
				}
				
				return response.json();
			})
			.then((response) => {
				pub.vscanReports = response.vscanReports;
				resolve();
			})
			.catch(err => {
				console.log(err.message);
				reject(err);
			});
		});
	};
	
	pub.getVscanDate = (vscanReport, includeTime = true) => {
		const d = new Date(vscanReport.updated);
		if (includeTime) {
			return `${d.toLocaleDateString("en-GB")} ${d.toLocaleTimeString("en-GB")}`;
		}
		else {
			return `${d.toLocaleDateString("en-GB")}`;
		}
	}
	
	return pub;
};

export default VscanService();